// extracted by mini-css-extract-plugin
module.exports = {"box":"Page5_box__25nXW","title":"Page5_title__1yINn","labelText":"Page5_labelText__2f9xp"};